import React                    from 'react';
import { withRouter }           from 'react-router';
import { login as authLogin, 
         logout as authLogout, 
         isLoggedIn }           from '../utils/authService';
import { NavDropdown }          from 'react-bootstrap';

class Login extends React.Component {

  login = () => {
    authLogin();
  }

  logout = () => {
    authLogout();
  }

  render() {
    
    if (!isLoggedIn()) {
      return (
        <NavDropdown.Item href={window.location.href} style={{ fontSize: '14px' }} className="anchor c-breadcrumbs__anchor" onClick={this.login}>
          Log in
          <i style={{ marginLeft: '2px' }} className="fas fa-user"></i>
        </NavDropdown.Item>
      )
    }
    
    return (
        <NavDropdown.Item href={window.location.href} style={{ fontSize: '14px' }} className="anchor c-breadcrumbs__anchor" onClick={this.logout}>
          Log out
          <i style={{ marginLeft: '2px' }} className="fas fa-user"></i>
        </NavDropdown.Item>
    )
  }
}

export default withRouter(Login);
